var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('pt-button', { staticClass: "save-button", class: { 'is-disabled': _vm.disabled }, attrs: { "type": _vm.PtButtonType.Outlined, "theme": _vm.PtButtonTheme.Primary }, on: { "click": function click($event) {
        !_vm.disabled && _vm.handleSave();
      } } }, [_vm._v("\n  " + _vm._s(_vm.$t('playTurbo.common.save.text')) + "\n")]);
};
var staticRenderFns = [];

export { render, staticRenderFns };